import { RegisterCard } from "../../components/RegisterCard";
import { CircleLoader } from "../../components/CircleLoader";
import { useEffect, useState } from "react";
import { LogOut, Clock, FileText } from "lucide-react";

export const CAlogout = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const [formattedTime, setFormattedTime] = useState("");

  useEffect(() => {
    if (formData.time) {
      setFormattedTime(formData.time.replace(" ", "T"));
    }
  }, [formData.time]);

  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace("T", " ");
    setFormattedTime(e.target.value);
    onFormChange("time", value);
  };

  return (
    <div className="w-full max-w-4xl mx-auto p-4">
      <RegisterCard
        title="Departure Log"
        details="Confirm the child's check-out time."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[2.5rem] border border-slate-100 shadow-xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 space-y-8 order-2 lg:order-1">
          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <Clock size={14} className="text-blue-600" /> Check-out Time
            </label>
            <input
              type="datetime-local"
              value={formattedTime}
              onChange={handleTimeChange}
              className="w-full h-14 px-5 bg-slate-50 border-2 border-slate-100 rounded-2xl font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all"
            />
          </div>

          <div className="space-y-3">
            <label className="flex items-center gap-2 text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              <FileText size={14} /> Pickup Notes
            </label>
            <textarea
              value={formData["description"]}
              onChange={(e) => onFormChange("description", e.target.value)}
              className="w-full p-5 bg-slate-50 border-2 border-slate-100 rounded-2xl min-h-[120px] outline-none focus:bg-white transition-all"
              placeholder="E.g. Picked up by Grandma, forgot lunchbox..."
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-blue-600 text-white rounded-2xl font-black uppercase tracking-widest hover:bg-blue-700 transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <LogOut size={20} /> Confirm Log Out
              </>
            )}
          </button>
        </div>

        <div className="lg:w-64 bg-blue-50 flex items-center justify-center p-8 order-1 lg:order-2 border-l border-slate-100">
          <img
            src="/img/log-in.svg"
            className="w-40 h-40 scale-x-[-1]"
            alt="logout"
          />
        </div>
      </form>
    </div>
  );
};
